module.exports = __webpack_public_path__ + "img/logo_short.7611f083.png";